module.exports = __webpack_public_path__ + "media/pages/assets/images/logo-9462ac6737360fb5e52a10de82de3f0b.svg";